import { ApiEndpointEnum, CustomErrorType, CustomUIErrorCode, ErrorTypeEnum } from '@ld.consumer-portal/models';

export const CUSTOM_ERROR_KEYS = {
  bankAccountCannotBeDeletedTitle: 'servicesAutopayErrorBankDeletePendingTitle',
  bankAccountDeleteRetryTitle: 'servicesAutopayErrorBankDeletePendingTitle',
  bankAccountDuplicateTitle: 'servicesAutopayErrorBankDuplicateTitle',
  paymentUnableToProcessTitle: 'servicesAutopayErrorDuplicateDateTitle',
  paymentScheduledProcessingTitle: 'constantsPaymentScheduledPaymentWarningTitle',

  bankAccountCannotBeDeletedMessage: 'servicesAutopayErrorBankDeletePendingMessage',
  bankAccountDeleteRetryMessage: 'servicesErrorsCustomBankAccountDeleteRetryMessage',
  bankAccountDuplicateMessage: 'servicesAutopayErrorBankDuplicateMessage',
  paymentDuplicateDateMessage: 'servicesAutopayErrorDuplicateDateMessage',
  paymentCutoffTimeMessage: 'servicesErrorsCustomPaymentCutoffTimeMessage',
  paymentWeekendHolidayMessage: 'servicesErrorsCustomPaymentWeekendHolidayMessage',
  paymentAutopayConflictMessage: 'servicesErrorsCustomPaymentAutopayConflictMessage',
  paymentAutopayExistsMessage: 'servicesErrorsCustomPaymentAutopayExistsMessage',
  paymentAutopayPrincipalMessage: 'servicesErrorsCustomPaymentAutopayPrincipalMessage',
  paymentScheduledWarningMessage: 'constantsPaymentScheduledPaymentWarningMessage',

  btnClose: 'commonAriaClose',
  btnBackToAccountSummary: 'paymentsReturnToAccountSummary',
  btnContinue: 'commonButtonsContinue',
  btnCancel: 'commonButtonsCancel',
} as const;

export const customErrorList: CustomErrorType[] = [
  {
    resultCode: '1001',
    url: ApiEndpointEnum.PaymentProfile,
    errorTitle: CUSTOM_ERROR_KEYS.bankAccountCannotBeDeletedTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.bankAccountCannotBeDeletedTitle,
    errorMessage: CUSTOM_ERROR_KEYS.bankAccountCannotBeDeletedMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.bankAccountCannotBeDeletedMessage,
    btnText: CUSTOM_ERROR_KEYS.btnClose,
    btnTextKey: CUSTOM_ERROR_KEYS.btnClose,
    errorType: ErrorTypeEnum.Warning,
  },
  {
    resultCode: CustomUIErrorCode.DeleteBankAccount,
    url: ApiEndpointEnum.PaymentProfile,
    errorTitle: CUSTOM_ERROR_KEYS.bankAccountDeleteRetryTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.bankAccountDeleteRetryTitle,
    errorMessage: CUSTOM_ERROR_KEYS.bankAccountDeleteRetryMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.bankAccountDeleteRetryMessage,
    btnText: CUSTOM_ERROR_KEYS.btnClose,
    btnTextKey: CUSTOM_ERROR_KEYS.btnClose,
    errorType: ErrorTypeEnum.Warning,
  },
  {
    resultCode: '1003',
    url: ApiEndpointEnum.PaymentProfile,
    errorTitle: CUSTOM_ERROR_KEYS.bankAccountDuplicateTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.bankAccountDuplicateTitle,
    errorMessage: CUSTOM_ERROR_KEYS.bankAccountDuplicateMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.bankAccountDuplicateMessage,
    btnText: CUSTOM_ERROR_KEYS.btnClose,
    btnTextKey: CUSTOM_ERROR_KEYS.btnClose,
    errorType: ErrorTypeEnum.Danger,
  },

  {
    resultCode: '2002',
    url: ApiEndpointEnum.Payments,
    errorTitle: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorMessage: CUSTOM_ERROR_KEYS.paymentDuplicateDateMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.paymentDuplicateDateMessage,
    btnText: CUSTOM_ERROR_KEYS.btnBackToAccountSummary,
    btnTextKey: CUSTOM_ERROR_KEYS.btnBackToAccountSummary,
    btnLink: '/dashboard',
    errorType: ErrorTypeEnum.Warning,
  },
  {
    resultCode: 'CS1001',
    url: ApiEndpointEnum.Payments,
    errorTitle: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorMessage: CUSTOM_ERROR_KEYS.paymentCutoffTimeMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.paymentCutoffTimeMessage,
    btnText: CUSTOM_ERROR_KEYS.btnBackToAccountSummary,
    btnTextKey: CUSTOM_ERROR_KEYS.btnBackToAccountSummary,
    btnLink: '/dashboard',
    errorType: ErrorTypeEnum.Warning,
  },
  {
    resultCode: 'CS1002',
    url: ApiEndpointEnum.Payments,
    errorTitle: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorMessage: CUSTOM_ERROR_KEYS.paymentWeekendHolidayMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.paymentWeekendHolidayMessage,
    btnText: CUSTOM_ERROR_KEYS.btnBackToAccountSummary,
    btnTextKey: CUSTOM_ERROR_KEYS.btnBackToAccountSummary,
    btnLink: '/dashboard',
    errorType: ErrorTypeEnum.Warning,
  },
  {
    resultCode: 'CS1004',
    url: ApiEndpointEnum.Payments,
    errorTitle: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorMessage: CUSTOM_ERROR_KEYS.paymentAutopayConflictMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.paymentAutopayConflictMessage,
    btnText: CUSTOM_ERROR_KEYS.btnClose,
    btnTextKey: CUSTOM_ERROR_KEYS.btnClose,
    errorType: ErrorTypeEnum.Warning,
  },
  {
    resultCode: 'CS1005',
    url: ApiEndpointEnum.Payments,
    errorTitle: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorMessage: CUSTOM_ERROR_KEYS.paymentAutopayExistsMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.paymentAutopayExistsMessage,
    btnText: CUSTOM_ERROR_KEYS.btnClose,
    btnTextKey: CUSTOM_ERROR_KEYS.btnClose,
    btnLink: '/dashboard',
    errorType: ErrorTypeEnum.Warning,
  },
  {
    resultCode: 'CS1006',
    url: ApiEndpointEnum.Payments,
    errorTitle: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.paymentUnableToProcessTitle,
    errorMessage: CUSTOM_ERROR_KEYS.paymentAutopayPrincipalMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.paymentAutopayPrincipalMessage,
    btnText: CUSTOM_ERROR_KEYS.btnClose,
    btnTextKey: CUSTOM_ERROR_KEYS.btnClose,
    errorType: ErrorTypeEnum.Warning,
  },

  {
    resultCode: CustomUIErrorCode.PaymentSetupWarning,
    url: null,
    errorTitle: CUSTOM_ERROR_KEYS.paymentScheduledProcessingTitle,
    errorTitleKey: CUSTOM_ERROR_KEYS.paymentScheduledProcessingTitle,
    errorMessage: CUSTOM_ERROR_KEYS.paymentScheduledWarningMessage,
    errorMessageKey: CUSTOM_ERROR_KEYS.paymentScheduledWarningMessage,
    btnText: CUSTOM_ERROR_KEYS.btnContinue,
    btnTextKey: CUSTOM_ERROR_KEYS.btnContinue,
    btnLink: '/payment',
    btnTextSecond: CUSTOM_ERROR_KEYS.btnCancel,
    btnTextSecondKey: CUSTOM_ERROR_KEYS.btnCancel,
    errorType: ErrorTypeEnum.Warning,
  },
];
